import React from 'react'
import Combaintop from '../Components/Combaintop/Top'
import Combainbottom from '../Components/Combainbottom/Combainbottom'
import ChangePassword from '../Components/Forgot/Forgotpassword';
function Forgotpass() {
    return (
        <>
        <Combaintop/>
        <ChangePassword/>
        <Combainbottom/>
        </>
        
    )
}

export default Forgotpass;
